import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.402 13.19H.598a.61.61 0 0 1-.52-.297.62.62 0 0 1 0-.6L6.48 1.09a.624.624 0 0 1 1.04 0l6.402 11.203a.62.62 0 0 1 0 .6.61.61 0 0 1-.52.296M1.63 11.988h10.74L7 2.594z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 8.788a.61.61 0 0 1-.6-.6V5.387a.6.6 0 1 1 1.2 0v2.8a.61.61 0 0 1-.6.601m0 2.401a.61.61 0 0 1-.6-.6v-.4a.6.6 0 1 1 1.2 0v.4a.61.61 0 0 1-.6.6"
    }, null, -1)
  ]))]))
}
export default { render: render }